const setAddressTab = (addressData,requestJSON) =>{
    if (addressData !== undefined && addressData !== {} && addressData !== undefined && addressData.length !== 0) {
        
        let mapAddressData = [] ;

        let addressJSON = {
            address1 : addressData.address_1 !== undefined && addressData.address_1 !== "" ? addressData.address_1 : "",
            address2 : addressData.address_2 !== undefined && addressData.address_2 !== "" ? addressData.address_2 : "",
            city : addressData.city !== undefined && addressData.city !== "" ? addressData.city : "",
            stateName : addressData.addressState !== undefined && addressData.addressState.value !== "" ? addressData.addressState.label : "",
            stateCode : addressData.addressState !== undefined && addressData.addressState.value !== "" ? addressData.addressState.value : "",
            postalCode : addressData.zipCode !== undefined && addressData.zipCode !== "" ? addressData.zipCode.replace(/-|\s/g, "") : "",
            county : addressData.county !== undefined && addressData.county.value !== "" ? addressData.county.value : ""
        }
        mapAddressData.push(addressJSON);
       
        requestJSON = { ...requestJSON, "addresses": mapAddressData };
    }
    return requestJSON;
}

export default setAddressTab